import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';

const ROUTES = ['advisory-tool', 'systems'];

export default class Navigation extends Component {

  /* Render */

  render() {
    const items = [];

    ROUTES.forEach((route) => {
      items.push((
        <li className="navigation__item" key={`sidebar-nav-${route}`}>
          <Link className="navigation__link" to={`/${route}`} activeClassName="is-active">
            <div className={`navigation__link__icon icon-${route}`} />
            <div className="navigation__link__label">
              <FormattedMessage id={`general.navigation.${route}`} />
            </div>
          </Link>
        </li>
      ));
    });

    return (
      <ul className="navigation">
        {items}
      </ul>
    );
  }
}



// WEBPACK FOOTER //
// ./js/components/navigation/index.jsx